// ---------------------------------------------------------------------------
// InvoiceRecord config helpers
// Phase 1: status, printStatus, sourceType, operation action
// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// Invoice status
// ---------------------------------------------------------------------------

export const invoiceStatusConfig = {
  pending: {
    value: 'pending',
    label: '待開立',
    tagType: 'info',
  },
  issued: {
    value: 'issued',
    label: '已開立',
    tagType: 'success',
  },
  invalid: {
    value: 'invalid',
    label: '已作廢',
    tagType: 'danger',
  },
  allowance: {
    value: 'allowance',
    label: '已折讓',
    tagType: 'warning',
  },
  partialAllowance: {
    value: 'partialAllowance',
    label: '部分折讓',
    tagType: 'warning',
  },
  markedAllowance: {
    value: 'markedAllowance',
    label: '標記折讓',
    tagType: 'warning',
  },
  markedVoided: {
    value: 'markedVoided',
    label: '標記作廢',
    tagType: 'danger',
  },
}

export const invoiceStatusOptions = Object.values(invoiceStatusConfig)

export const getInvoiceStatusLabel = (status) => {
  return invoiceStatusConfig[status]?.label || '-'
}

export const getInvoiceStatusTagType = (status) => {
  return invoiceStatusConfig[status]?.tagType || 'info'
}

// ---------------------------------------------------------------------------
// Print status
// ---------------------------------------------------------------------------

export const invoicePrintStatusConfig = {
  none: {
    value: 'none',
    label: '未列印',
    tagType: 'info',
  },
  pendingPrint: {
    value: 'pendingPrint',
    label: '待列印',
    tagType: 'warning',
  },
  printed: {
    value: 'printed',
    label: '已列印',
    tagType: 'success',
  },
  printFailed: {
    value: 'printFailed',
    label: '列印失敗',
    tagType: 'danger',
  },
}

export const invoicePrintStatusOptions = Object.values(invoicePrintStatusConfig)

export const getInvoicePrintStatusLabel = (status) => {
  return invoicePrintStatusConfig[status]?.label || '-'
}

export const getInvoicePrintStatusTagType = (status) => {
  return invoicePrintStatusConfig[status]?.tagType || 'info'
}

export const invoiceTestPrintStatusConfig = {
  pending: { label: '待測試', tagType: 'warning', value: 'pending' },
  success: { label: '成功', tagType: 'success', value: 'success' },
  failed: { label: '失敗', tagType: 'danger', value: 'failed' },
}

// ---------------------------------------------------------------------------
// Source type
// ---------------------------------------------------------------------------

export const invoiceSourceTypeConfig = {
  manual: {
    value: 'manual',
    label: '手動開立',
  },
  salesRecord: {
    value: 'salesRecord',
    label: '銷售紀錄',
  },
  course: {
    value: 'course',
    label: '課程',
  },
  appointmentCheckout: {
    value: 'appointmentCheckout',
    label: '預約結帳',
  },
  memberStore: {
    value: 'memberStore',
    label: '會員商城',
  },
  pubApt: {
    value: 'pubApt',
    label: '跨境預約',
  },
  ecommerce: {
    value: 'ecommerce',
    label: '電商',
  },
}

export const invoiceSourceTypeOptions = Object.values(invoiceSourceTypeConfig)

export const invoiceNativeRecordSourceTypes = ['manual', 'salesRecord']

export const getInvoiceSourceTypeLabel = (sourceType) => {
  return invoiceSourceTypeConfig[sourceType]?.label || '-'
}

// ---------------------------------------------------------------------------
// Operation action
// ---------------------------------------------------------------------------

export const invoiceOperationActionConfig = {
  issue: {
    value: 'issue',
    label: '開立',
  },
  invalid: {
    value: 'invalid',
    label: '作廢',
  },
  allowance: {
    value: 'allowance',
    label: '折讓',
  },
  reprint: {
    value: 'reprint',
    label: '補印發票',
  },
}

export const invoiceOperationActionOptions = Object.values(invoiceOperationActionConfig)

export const getInvoiceOperationActionLabel = (action) => {
  return invoiceOperationActionConfig[action]?.label || '-'
}
